/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_H2Inputs */

const en_sorter_ref_h2 = /** @type {(inputs: Sorter_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tool`)
};

const ko_sorter_ref_h2 = /** @type {(inputs: Sorter_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도구`)
};

const ja_sorter_ref_h2 = /** @type {(inputs: Sorter_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このツール`)
};

/**
* | output |
* | --- |
* | "This tool" |
*
* @param {Sorter_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_h2 = /** @type {((inputs?: Sorter_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_h2(inputs)
	if (locale === "ko") return ko_sorter_ref_h2(inputs)
	return ja_sorter_ref_h2(inputs)
});